export const payrollOptions = [
  { value: "caelius", label: "Caelius" },
  { value: "IVYClinic", label: "IvyClinic" },
];
